import I18n from 'I18n';
import enviro from 'enviro';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { baseReviewabilityDefaults } from '../constants/Reviewability';
import * as UnreviewableReasons from '../constants/UnreviewableReason';
const appReviewabilityDefaults = Object.assign({
  isPublic: null,
  installedAt: 0,
  uninstalledAt: 0,
  maxMillisAfterUninstall: 0
}, baseReviewabilityDefaults);
export default class AppReviewability extends createImmutableObjectClass(appReviewabilityDefaults) {
  getUnreviewableReason() {
    const {
      isPublic,
      installedAt,
      uninstalledAt,
      portalReviewsCount,
      userAlreadyReviewed,
      userOnProviderPortal,
      testPortal,
      maxPortalReviews,
      maxMillisAfterUninstall
    } = this;
    const withinUninstallWindow = !uninstalledAt || I18n.moment().diff(I18n.moment(uninstalledAt)) < maxMillisAfterUninstall;
    const withinReviewLimit = portalReviewsCount < maxPortalReviews;
    const isQa = enviro.isQa();

    if (isPublic) {
      return UnreviewableReasons.PUBLIC_USER;
    } else if (!installedAt && !isQa) {
      return UnreviewableReasons.NOT_INSTALLED;
    } else if (!withinUninstallWindow && !isQa) {
      return UnreviewableReasons.UNINSTALLED;
    } else if (!withinReviewLimit && !isQa) {
      return UnreviewableReasons.LIMIT_REACHED;
    } else if (userAlreadyReviewed) {
      return UnreviewableReasons.ALREADY_REVIEWED;
    } else if (userOnProviderPortal && !isQa) {
      return UnreviewableReasons.PROVIDER_USER;
    } else if (testPortal) {
      return UnreviewableReasons.TEST_PORTAL_USER;
    } else {
      return false;
    }
  }

  isReviewable() {
    return !this.getUnreviewableReason();
  }

}